<div class=" p-2 min-w-[80%]">
	<div class="flex items-center gap-2 mb-5">
		<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg" width="40" height="40" alt="Anuprerna">
		<h1 class="text-2xl uppercase text-[#8E7862]">Anuprerna</h1>
	</div>
	<div class="fb-login-form-container flex flex-col ">
		<div class="flex gap-2 items-center">
			<span (click)="authProvider.emit(AuthProviderEnum.UNKNOWN)"
				  class="material-symbols-outlined cursor-pointer">
				arrow_back_ios
			</span>
			<h3 *ngIf="!loginFailure" class="font-medium text-2xl mb-2">Sign in with email</h3>
			<h3 *ngIf="loginFailure" class="font-medium text-2xl mb-2">Incorrect Password</h3>
		</div>
		<p *ngIf="!loginFailure" class="text-[#9fa6b8]">
			Seems like you already have an account with <span class="text-black">{{ emailFormControl.value }}</span>. Enter your password to sign in
		</p>
		<p *ngIf="loginFailure" class="text-[#9fa6b8]">
			You have entered the wrong password for your account with {{ emailFormControl.value }}.
			Retry with another password or continue using a different sign-in option or reset your password
		</p>
		<div class="fb-login-form my-3 ">
			<form [formGroup]="loginFormGroup"
				  (ngSubmit)="basicLogin()">
				<div class="my-2.5">
					<label for="password" class="text-sm font-bold">Password :</label>
					<div class=" w-full border border-[##F0F5FA] rounded flex items-center justify-between gap-0.5 pr-2">
						<input class="w-full px-2 py-2 md:min-w-[300px]"
							   [type]="passwordType"
							   id="password"
							   name="password"
							   [formControl]="passwordFormControl"
							   placeholder="Enter your password"/>
						<div (click)="passwordType==='text'? passwordType='password': passwordType='text'"
							 class="cursor-pointer">
										<span *ngIf="passwordType==='password'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility</span>
							<span *ngIf="passwordType==='text'"
								  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility_off</span>
						</div>
					</div>

					<ng-container>
						<p class="text-red-500 text-xs"
						   *ngIf="loginFormGroup.controls['password'].invalid && loginFormGroup.controls['password'].dirty">
							Password is required. Minimum 8 characters.
						</p>
					</ng-container>
				</div>
				<div class="w-full flex justify-end">
					<a class="text-sm text-[#8E7862]"
					   routerLink="/auth/forget-password">Forgot Password?</a>
				</div>
				<button class="w-full mt-5 rounded bg-[#8E7862] text-white py-2 hover:bg-[#6c5b48] transition-colors"
						type="submit">
					Sign In
				</button>
			</form>

			<div *ngIf="loginFailure"
				 class="fb-auth-provider my-3">
				<div class="flex flex-col justify-between gap-2">
					<button (click)="getAuthProvider(AuthProviderEnum.GOOGLE)"
							class="w-full mt-2 rounded border-2 border-[#8E7862] text-[#8E7862] py-2 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"
							type="submit">
						<img ngSrc="assets/img/google_logo.svg" width="20" height="20" alt="Google">
						Continue with Google
					</button>
					<!--				<button (click)="getAuthProvider(AuthProviderEnum.FACEBOOK)"-->
					<!--						class="w-full mt-2 rounded border-2 border-[#8E7862] text-[#8E7862] py-2 hover:border-[#6c5b48]-->
					<!--						transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"-->
					<!--						type="submit">-->
					<!--					<img ngSrc="assets/img/fb_blue.svg" width="20" height="20" alt="Facebook">-->
					<!--					Continue with Facebook-->
					<!--				</button>-->

				</div>
			</div>
		</div>
	</div>
</div>
